import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { Tables } from "../../../gen/tableNames/tables";
import { Clients } from "../../../lib/clients";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";

const filterG4SustainAnalyticsSchema = z.object({
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  sustainalytics_id_equals: z.string().optional(),
});

export type FilterG4SustainAnalyticsSchema = z.infer<
  typeof filterG4SustainAnalyticsSchema
>;

export function FilterG4Sustainanalytics() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "date",
      type: "dateRange",
      copy_from_to_when_to_empty: true,
      label: t(`${Tables.G4_SUSTAINALYTICS_ESG}.columns.date`),
      from: { name: "date_from" },
      to: { name: "date_to" },
      col_span: 2,
    },
    {
      name: "sustainalytics_id_equals",
      label: t(`${Tables.G4_SUSTAINALYTICS_ESG}.columns.sustainalytics_id`),
      type: "input",
    },
  ];

  return (
    <FilterTable
      columns={2}
      client={Clients.G4}
      schema={filterG4SustainAnalyticsSchema}
      tableName={Tables.G4_SUSTAINALYTICS_ESG}
      fields={fields}
    />
  );
}
